import { render } from "./SongDislikesList.vue?vue&type=template&id=03969d5f"
import script from "./SongDislikesList.vue?vue&type=script&lang=js"
export * from "./SongDislikesList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__